// Tipo usado pela entidade genérica `Tag` para diferenciar a tag de atividade (`service_orders`)
// da tag de pergunta de checklist (`question`), já existente. Ver `Models.Tag` no back-elixir.
export const ACTIVITY_TAG_TYPE = 'service_orders'
